<template>
  <div class="business-page">
    <Header />
    
    <div class="page-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <div class="title-wrapper">
          <h1>我们的业务</h1>
          <p>专业的猎头服务，为您寻找最合适的人才</p>
          <div class="scroll-indicator">
            <span>向下滚动了解更多</span>
            <i class="bi bi-chevron-down"></i>
          </div>
        </div>
      </div>
    </div>
    
    <section class="business-detail">
      <div class="container">
        <div class="section-title">
          <span class="subtitle">服务流程</span>
          <h2>俊采猎头服务</h2>
          <div class="divider"></div>
          <p>让每个人都得到发展，愿意与每个客户共同进步</p>
        </div>
        
        <div class="service-roadmap">
          <div class="roadmap-item">
            <div class="roadmap-icon">
              <span class="step">01</span>
              <i class="bi bi-search"></i>
            </div>
            <div class="roadmap-content">
              <h3>了解需求</h3>
              <p>我们会深入了解客户企业文化和发展战略，确定职位描述，明确岗位需求，以便寻访到最合适的人才。</p>
            </div>
          </div>

          <div class="roadmap-item">
            <div class="roadmap-icon">
              <span class="step">02</span>
              <i class="bi bi-geo-alt"></i>
            </div>
            <div class="roadmap-content">
              <h3>人才寻访</h3>
              <p>分析候选人可能服务的公司或机构，制定人才寻访地图。我们通过多种渠道主动寻访，搜索人才，同时进行初步筛选。</p>
            </div>
          </div>

          <div class="roadmap-item">
            <div class="roadmap-icon">
              <span class="step">03</span>
              <i class="bi bi-bar-chart"></i>
            </div>
            <div class="roadmap-content">
              <h3>面试评估</h3>
              <p>从能力、业绩以及潜力等方面对候选人进行全面面试和评估，形成候选人评估报告，确保人才的专业能力和文化适配性。</p>
            </div>
          </div>

          <div class="roadmap-item">
            <div class="roadmap-icon">
              <span class="step">04</span>
              <i class="bi bi-person"></i>
            </div>
            <div class="roadmap-content">
              <h3>人才推荐</h3>
              <p>为每个职位推荐多位适配的候选人供客户选择面试，向客户提供候选人的背景和评估报告，并安排客户与候选人的面试。</p>
            </div>
          </div>

          <div class="roadmap-item">
            <div class="roadmap-icon">
              <span class="step">05</span>
              <i class="bi bi-calendar-check"></i>
            </div>
            <div class="roadmap-content">
              <h3>跟踪服务</h3>
              <p>持续跟踪服务候选人并和客户保持实时沟通，协助客户与候选人的薪资谈判，促成最终录用，并提供入职后的跟踪服务。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <h3>需要专业猎头顾问？</h3>
          <p>我们为您提供一站式企业人才招聘解决方案</p>
          <a href="#" class="cta-button">立即咨询</a>
        </div>
      </div>
    </section>
    
    <section class="advantages">
      <div class="container">
        <div class="section-title">
          <span class="subtitle">为什么选择我们</span>
          <h2>我们的优势</h2>
          <div class="divider"></div>
          <p>专注、专心、专业</p>
        </div>
        
        <div class="advantage-list">
          <div class="advantage-item">
            <div class="number-wrapper">
              <div class="number">1</div>
            </div>
            <h3>人才积累</h3>
            <p>庞大的人才库，覆盖多个行业，能快速精准地匹配企业需求。</p>
            <div class="advantage-icon">
              <i class="bi bi-database"></i>
            </div>
          </div>
          
          <div class="advantage-item">
            <div class="number-wrapper">
              <div class="number">2</div>
            </div>
            <h3>专业团队</h3>
            <p>专业顾问团队，从业经验丰富，对各行业有深入研究。</p>
            <div class="advantage-icon">
              <i class="bi bi-people"></i>
            </div>
          </div>
          
          <div class="advantage-item">
            <div class="number-wrapper">
              <div class="number">3</div>
            </div>
            <h3>高效服务</h3>
            <p>精益猎头模式，提高猎头服务效率，缩短候选人寻访时间。</p>
            <div class="advantage-icon">
              <i class="bi bi-lightning"></i>
            </div>
          </div>
          
          <div class="advantage-item">
            <div class="number-wrapper">
              <div class="number">4</div>
            </div>
            <h3>行业洞察</h3>
            <p>深入了解供应链、新能源、电力、互联网等行业，提供精准人才解决方案。</p>
            <div class="advantage-icon">
              <i class="bi bi-graph-up"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'BusinessPage',
  components: {
    Header,
    Footer
  }
}
</script>

<style scoped>
.business-page {
  overflow-x: hidden;
}

.page-banner {
  height: 500px;
  background-image: url('@/assets/wallpaper7.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.5) 100%);
}

.banner-content {
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 48px;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 1px;
  font-weight: 700;
  width: 100%;
  text-align: center;
}

.banner-content p {
  font-size: 20px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  margin-bottom: 40px;
  width: 100%;
  text-align: center;
}

.scroll-indicator {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  animation: bounce 2s infinite;
  text-align: center;
  width: 100%;
}

.scroll-indicator span {
  font-size: 14px;
  margin-bottom: 5px;
  opacity: 0.8;
}

.scroll-indicator i {
  font-size: 20px;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
}

.subtitle {
  display: inline-block;
  color: #009688;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  position: relative;
}

.subtitle:before, .subtitle:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background-color: #009688;
}

.subtitle:before {
  right: -30px;
}

.subtitle:after {
  left: -30px;
}

.section-title h2 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #1a2b2b;
  font-weight: 700;
}

.divider {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #009688, #4CAF50);
  margin: 0 auto 20px;
  border-radius: 3px;
}

.section-title p {
  font-size: 18px;
  color: #6a7676;
  max-width: 700px;
  margin: 0 auto;
}

.business-detail {
  padding: 60px 0 160px 0;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}

/* 新设计的路线图样式 */
/* 服务流程：清爽的水平时间线 */
.service-roadmap {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  max-width: 1200px;
  margin: 20px auto 0;
  padding: 40px 0 20px;
}

/* 贯穿各步骤图标中心的连接线 */
.service-roadmap::before {
  content: "";
  position: absolute;
  top: 76px;                 /* 与图标垂直中心对齐（padding 40 + 图标半径 36） */
  left: 10%;
  right: 10%;
  height: 3px;
  background: linear-gradient(to right, #009688, #4CAF50);
  opacity: 0.35;
  z-index: 0;
}

.roadmap-item {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.roadmap-icon {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  box-shadow: 0 10px 22px rgba(0, 150, 136, 0.28);
  flex-shrink: 0;
  margin-bottom: 24px;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.roadmap-item:hover .roadmap-icon {
  transform: translateY(-4px) rotate(-6deg);
}

.roadmap-icon .step {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #009688;
  box-shadow: 0 4px 10px rgba(0, 150, 136, 0.2);
}

.roadmap-icon i {
  font-size: 30px;
  color: #fff;
}

.roadmap-content {
  background-color: #fff;
  padding: 26px 22px;
  border-radius: 16px;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  position: relative;
  transition: transform .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color .4s ease;
  width: 100%;
  flex: 1;
}

.roadmap-content h3 {
  font-size: 19px;
  margin-bottom: 12px;
  color: #1a2b2b;
  font-weight: 600;
}

.roadmap-content p {
  font-size: 14px;
  line-height: 1.7;
  color: #6a7676;
  margin: 0;
}

.roadmap-item:hover .roadmap-content {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

/* 响应式：平板转为多行网格，隐藏横向连接线 */
@media (max-width: 992px) {
  .service-roadmap {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    padding: 20px 0;
  }

  .service-roadmap::before {
    display: none;
  }
}

@media (max-width: 576px) {
  .service-roadmap {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

.cta-section {
  padding: 80px 0;
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #009688, #4CAF50);
  color: #fff;
  overflow: hidden;
}

.cta-section:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,0 L100,0 L100,100 L0,100 Z" fill="rgba(255,255,255,0.05)"/></svg>');
  background-size: 20px 20px;
  opacity: 0.5;
}

.cta-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.cta-content h3 {
  font-size: 36px;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-content p {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.9;
}

.cta-button {
  display: inline-block;
  padding: 15px 40px;
  background-color: #fff;
  color: #009688;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 10px;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
}

.cta-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.25);
}

.advantages {
  padding: 100px 0;
  background-color: #f8f9fa;
}

.advantage-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
}

.advantage-item {
  text-align: center;
  padding: 40px 15px;
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #eef1f0;
  box-shadow: 0 4px 18px rgba(20, 40, 40, 0.05);
  transition: transform .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              box-shadow .4s cubic-bezier(0.165, 0.84, 0.44, 1),
              border-color .4s ease;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.advantage-item:hover {
  transform: translateY(-10px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(0, 121, 107, 0.18);
}

.number-wrapper {
  position: relative;
  width: 64px;
  height: 64px;
  margin: 0 auto 25px;
}

.advantage-item .number {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #009688 0%, #4CAF50 100%);
  color: #fff;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 700;
  box-shadow: 0 10px 22px rgba(0, 150, 136, 0.28);
  position: relative;
  z-index: 1;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.advantage-item:hover .number {
  transform: translateY(-4px) rotate(-6deg);
}

.advantage-item h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #1a2b2b;
  font-weight: 600;
}

.advantage-item p {
  font-size: 15px;
  line-height: 1.7;
  color: #6a7676;
}

.advantage-icon {
  position: absolute;
  right: 20px;
  bottom: 20px;
  opacity: 0.1;
  font-size: 48px;
  color: #009688;
  transition: all 0.3s;
}

.advantage-item:hover .advantage-icon {
  opacity: 0.2;
  transform: scale(1.2);
}

@media (max-width: 768px) {
  .page-banner {
    height: 350px;
    margin-top: 70px;
  }
  
  .banner-content h1 {
    font-size: 30px;
  }
  
  .banner-content p {
    font-size: 16px;
  }
  
  .section-title h2 {
    font-size: 26px;
  }
  
  .advantage-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

@media (max-width: 576px) {
  .page-banner {
    height: 300px;
    margin-top: 60px;
  }
  
  .banner-content h1 {
    font-size: 24px;
  }
  
  .advantage-list {
    grid-template-columns: 1fr;
  }
}
</style> 